import { render, staticRenderFns } from "./IdentificacaoCliente.vue?vue&type=template&id=0d826a34&scoped=true&"
import script from "./IdentificacaoCliente.vue?vue&type=script&lang=js&"
export * from "./IdentificacaoCliente.vue?vue&type=script&lang=js&"
import style0 from "./IdentificacaoCliente.vue?vue&type=style&index=0&id=0d826a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d826a34",
  null
  
)

export default component.exports